
<template>
  <div>
    <div class="card-header py-3">
      <h4 class="mb-0">{{ $t("account_page_timeline.title") }}</h4>
    </div>
    <div class="card-body">
      <p>{{ $t("account_page_timeline.intro") }}</p>
      <p v-if="isDataLoaded">
        {{ $t("account_page_timeline.url_link") }}:
        <a
          :href="timeline.value.timeline_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ timeline.value.timeline_url }}
        </a>
      </p>
      <p>{{ $t("account_page_timeline.text_1") }}</p>
      <p>
        <b>{{ $t("account_page_timeline.check_in") }}</b>
        {{ $t("account_page_timeline.check_in_text") }}
      </p>
      <p>
        <b>{{ $t("account_page_timeline.check_out") }}</b>
        {{ $t("account_page_timeline.check_out_text") }}
      </p>
      <p>{{ $t("account_page_timeline.text_2") }}</p>
      <p class="text-danger">
        <strong>{{ $t("account_page_timeline.note") }}</strong>
      </p>
      <div class="d-flex align-items-center mb-3">
        <p class="mb-0 mr-3">{{ $t("account_page_timeline.send_link") }}</p>
        <!-- Button trigger -->
        <b-button v-b-modal.sendEmailModal variant="info">
          {{ $t("account_page_timeline.send_email_label") }}
        </b-button>
      </div>
      <div>
        <p class="mb-1">
          <b>{{ $t("account_page_timeline.screen_display_title") }}</b>
        </p>
        <ul class="screen-display-list">
          <li v-for="n in 7" :key="n">
            {{ $t("account_page_timeline.screen_display_" + n) }}
          </li>
        </ul>
      </div>
      <div class="row mt-4">
        <div class="col-lg-12 text-center">
          <router-link to="/dashboard" class="btn btn-danger">{{
            $t("help.back")
          }}</router-link>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <b-modal
      body-class="p-0"
      size="md"
      id="sendEmailModal"
      centered
      :title="$t('send_test_email.header')"
      hide-footer
    >
      <form @submit="submitForm">
        <div slot="modal-body" class="modal-body">
          <div v-if="success" class="alert alert-success" role="alert">
            {{ $t("send_test_email.email-sent") }}
          </div>
          <div class="form-group row">
            <label class="col-12 col-form-label">
              {{ $t("send_test_email.email") }}
              <i
                class="far fa-question-circle text-primary"
                v-b-tooltip.top
                :title="$t('send_test_email.tooltip')"
              ></i>
            </label>
            <div class="col-12">
              <input
                type="text"
                v-model="email"
                class="form-control"
                placeholder="email1@site.com,email2@site.com,email3@site.com"
                required="true"
              />
            </div>
          </div>
        </div>
        <!-- custom buttons -->
        <div slot="modal-footer" class="modal-footer">
          <button class="btn btn-primary mr-3">
            {{ $t("send_test_email.submit") }}
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style scope scoped>
</style>
<script>
export default {
  data() {
    const facility = window._app_facility;

    return {
      facility: facility,
      isLoaded: false, // track digital key loading state
      isDataLoaded: false, // track if data is successfully loaded
      timeline: null,
      email: "",
      success: false,
    };
  },

  async mounted() {
    await this.getSetting();
  },

  methods: {
    async getSetting() {
      this.isLoaded = true;

      try {
        const response = await this.$lionheart.get(
          `/v2/facility-settings/guest-timeline`,
          {
            params: {
              facility_id: this.facility.id,
            },
          }
        );
        console.log(response.data.data, response.data.http_status);
        if (response.data.http_status === 200) {
          this.timeline = response.data.data.setting;
          this.isDataLoaded = true;
        }
      } catch (error) {
        console.error(error);
        this.isDataLoaded = false;
      } finally {
        this.isLoaded = false;
      }
    },

    async submitForm(e) {
      e.preventDefault();

      // convert comma-separated emails → array
      const emails = this.email
        .split(",")
        .map((e) => e.trim())
        .filter(Boolean);

      if (!emails.length) {
        return;
      }

      try {
        const response = await this.$lionheart.post(
          `/v2/facility-settings/guest-timeline/send-email`,
          {
            facility_id: this.facility.id,
            emails: emails,
            language: this.$i18n.locale,
          }
        );

        if (response.data.success) {
          this.success = true;
          this.email = "";

          setTimeout(() => {
            this.success = false;
          }, 5000);
        }
      } catch (error) {
        console.error("Send email failed:", error);
      }
    },
  },
};
</script>
<style scoped>
.screen-display-list {
  list-style: disc outside;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
</style>